<template>
	<Modal
		:theme="$arenaConfig.isLightTheme ? null : 'dark'"
		class="payment__modal"
		modal-name="PaymentModal"
		:closeable="closeable"
		:render-only-when-active="true"
		data-testid="payment-modal"
		@opened="onOpen"
	>
		<template #title>
			{{ $I18n.trans('payments.modal.title_' + mode ) }}
		</template>
		<template #content>
			<PaymentFlow
				ref="paymentFlow"
				:event="event"
				:auto-init="false"
				@hook:mounted="onPaymentFlowMounted"
				@closeable-change="closeable = $event"
			/>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal';
import PaymentFlow from '@js/components/Payments/PaymentFlow.vue';

export default {
	name:       'PaymentModal',
	components: { Modal, PaymentFlow },
	props:      {
		event: {
			type:     Object,
			required: false,
			default:  null,
		},
	},
	data() {
		return {
			closeable:             true,
			pendingOptions:        null,
			initializationStarted: false,
		};
	},
	computed: {
		mode() {
			return this.event ? 'event' : 'subscription';
		},
	},
	methods: {
		onPaymentFlowMounted() {
			// Ensure initialization runs once child ref is definitely available.
			this.initializePaymentFlow();
		},
		onOpen(options) {
			this.pendingOptions = options || {};
			this.initializationStarted = false;
			this.$nextTick(this.initializePaymentFlow);
		},
		initializePaymentFlow() {
			if (!this.$refs.paymentFlow || this.initializationStarted) {
				return;
			}

			// Both the modal-open and child-mounted hooks can run in the same render cycle.
			this.initializationStarted = true;
			this.$refs.paymentFlow.initialize(this.pendingOptions || {});
		},
	},
};
</script>
